import { render, staticRenderFns } from "./ModelsItem.vue?vue&type=template&id=8c2410a4&scoped=true&"
import script from "./ModelsItem.vue?vue&type=script&lang=js&"
export * from "./ModelsItem.vue?vue&type=script&lang=js&"
import style0 from "./ModelsItem.vue?vue&type=style&index=0&id=8c2410a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2410a4",
  null
  
)

export default component.exports